/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */
'use strict'

// 3rd party
import React from 'react'

// walrus
import { accessibilityLabel } from '@components/kit/_support'
import ScrollView, { ScrollViewProps } from '@components/kit/scroll-view'

// lib
import Content from '@components/content'
import Notes from './notes'
import Calls from './calls'
import MemberGoals from './member-goals'
import ClinicalImpactLogging from './clinical-impact-logging'
import GLP1Summary from './glp1-summary'
import QuestionsCards from './questions-cards'
import OpportunitiesReview from './opportunities-review'
import MemberSavings from './member-savings'
import GLP1Card from './glp1-card/glp1-card'

/* -----------------------------------------------------------------------------
 * ClinicalWork
 * -------------------------------------------------------------------------- */

export type ClinicalWorkProps = ScrollViewProps & {
  closeClinicalWork: () => void
}

function ClinicalWork({ closeClinicalWork, ...rest }: ClinicalWorkProps) {
  return (
    <ScrollView {...accessibilityLabel('Clinical Work')} {...rest}>
      <Content mt='-24'>
        <MemberSavings />
        <OpportunitiesReview />
        <GLP1Card />
        {/* <QuestionsCards /> */}
        <Notes />
        {/* <GLP1Summary /> -- deprecated, GLP1Card handles it better, but needs more context to remove */}
        <MemberGoals />
        <ClinicalImpactLogging />
        <Calls />
      </Content>
    </ScrollView>
  )
}

export default ClinicalWork
